import React, { useEffect, useState } from 'react'
import { Button, notification } from 'antd'
import type { TemplatesTableColumn } from '@src/components/TemplatesTable'
import type { ILang, ITemplate } from '@src/interfaces'
import Card from '@src/modules/atoms/card'
import { getPdfLink, getTemplatesByWorkspace } from '@src/services/config.service'
import LanguageSelector, { Languages } from '@src/modules/atoms/language-selector'
import { startDownloadFileByLink } from '@src/helpers/start-download-file'
import { currentUserLang } from '@src/helpers/current-user-lang'
import { notificationAlert } from '@src/modules/atoms/notification'
import { TemplatesTable } from '@src/components/TemplatesTable'

interface TemplateForUserProps {
  baseUrl: string
  context: string
  resource: number
  enterpriseToken: string
  workspace: string
  onClickEvent?: any
  queryParams?: any
}

const userLang = currentUserLang()

export const TemplatesForUser: React.FC<TemplateForUserProps> = ({
  baseUrl,
  context,
  resource,
  workspace,
  enterpriseToken,
  onClickEvent,
  queryParams = {}
}) => {
  const baseProps = { baseUrl, context, resource }
  const [templates, setTemplates] = useState<ITemplate[]>([])
  const [lang, setLang] = useState<ILang>(() => {
    const selectedLang = Languages.find(({ code }) => code === userLang)
    return selectedLang || { code: 'es', label: 'Español' }
  })
  const headers: TemplatesTableColumn[] = [
    {
      title: 'Nombre',
      key: 'title',
      sorteable: true
    },
    {
      title: '',
      key: 'actions',
      align: 'right',
      render: function (_: any, template: any) {
        return (
          <Button
            className='rkm-btn-info'
            onClick={() => {
              onClickDownload(template)
            }}
          >
            Descargar plantilla
          </Button>
        )
      }
    }
  ]

  const onClickDownload = (template: any) => {
    if (onClickEvent) {
      onClickEvent(template)
      return
    }

    downloadIndividualResult(template)
  }

  const downloadIndividualResult = (template: any) => {
    const { token: templateToken, workspace } = template
    notificationAlert({
      key: 'downloadIndividualResultPreparing',
      message: 'Generando archivo...',
      description: 'Tu archivo está siendo generado, la descarga empezará en unos segundos.',
      variant: 'info'
    })

    getPdfLink(baseProps, workspace, templateToken, queryParams, lang.code).then(
      ({ success, url }) => {
        if (success) {
          notification.close('downloadIndividualResultPreparing')
          notificationAlert({
            key: 'downloadIndividualResultStart',
            message: 'Archivo generado exitosamente',
            description: 'Comenzando la descarga',
            variant: 'success'
          })

          const link = `${baseUrl}/${url}&enterprise_token=${enterpriseToken}`
          startDownloadFileByLink(link)
        }
      }
    )
  }

  useEffect(() => {
    getTemplatesByWorkspace(baseProps, workspace, lang.code).then(({ data }) => {
      setTemplates(data)
    })
  }, [lang])

  return (
    templates && (
      <Card className='RankmiTemplatesForUser-card'>
        <LanguageSelector
          defaultLang={lang}
          onSelectedLang={(selectedLang: ILang) => {
            setLang(selectedLang)
          }}
        />
        <TemplatesTable templates={templates} columnHeaders={headers} />
      </Card>
    )
  )
}
